import { useEffect, useRef } from 'react';
import debounce from 'lodash/debounce';
import api, { apiWithRetry } from '../utils/api';

const useFilterApi = (
  url: string | null,
  setter: (data: any[]) => void,
  resetDownstream?: () => void,
  setLoading?: (loading: boolean) => void,
  debounceDelay = 400,
) => {
  const controllerRef = useRef<AbortController | null>(null);

  const fetchData = async () => {
    if (!url) return;

    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    const controller = new AbortController();
    controllerRef.current = controller;

    try {
      resetDownstream?.();
      setLoading?.(true);

      const res = await apiWithRetry(() => api.get(url, { signal: controller.signal }));

      if (res?.data?.success) {
        setter(res.data.data);
      }
    } catch (err: any) {
      if (err.name === 'CanceledError') return;
      console.error('API error:', err);
    } finally {
      setLoading?.(false);
    }
  };

  const debouncedFetch = debounce(fetchData, debounceDelay);

  useEffect(() => {
    if (!url) return;

    debouncedFetch();

    return () => {
      debouncedFetch.cancel();
      controllerRef.current?.abort();
    };
  }, [url]);
};

export default useFilterApi;
